<template>
	<ul role="navigation" class="pagination">
		<li class="page-item" :class="[paginator.currentPage === 1 ? 'disabled '  : ' ']">
			<a v-if="paginator.currentPage > 1" @click="previousPage" class="page-link">‹</a>
			<span v-else class="page-link">‹</span>
		</li>
		<li class="page-item" v-for="(url, index) in paginator.urls" :class="[index == paginator.currentPage ? 'active '  : ' ']">
			<span v-if="paginator.currentPage > 3 && index == 2" class="page-link">...</span>

			<span v-if="paginator.currentPage < Object.keys(paginator.urls).length - 3 && index == Object.keys(paginator.urls).length - 1" class="page-link">...</span>

			<span v-if="index == paginator.currentPage" class="page-link">{{ index }}</span>
			<a v-else-if="index == 1 || index == paginator.currentPage + 1 || index == paginator.currentPage + 2 || index == paginator.currentPage - 1 || index == Object.keys(paginator.urls).length" @click="gotoPage(index)" class="page-link">{{ index }}</a>
		</li>
		<li class="page-item" :class="[paginator.currentPage == Object.keys(paginator.urls).length ? 'disabled '  : ' ']">
			<a v-if="paginator.currentPage < Object.keys(paginator.urls).length" @click="nextPage" class="page-link">›</a>
			<span v-else class="page-link">›</span>
		</li>
	</ul>
</template>

<script>
	import {eventBus} from '../app'

	export default {
		name: 'PaginatorApi',
		props: {
			dataPaginator: {
				type: Object
			},
			dataLimit: {
				type: Number
			}
		},
		data() {
			return {
				paginator: this.dataPaginator,
				limit: this.dataLimit
			}
		},
		created() {
			let vm = this;
			eventBus.$on('changePage', function (data) {
				vm.changePage(data);
			});
			eventBus.$on('filter', function (filterString) {
				vm.filter = filterString;
			});
			eventBus.$on('changeLimit', function (limit) {
				vm.limit = limit;
				vm.changePage();
			});
		},
		methods: {
			nextPage: function () {
				this.paginator.currentPage++;
				if (this.paginator.currentPage > Object.keys(this.paginator.urls).length) {
					this.paginator.currentPage = Object.keys(this.paginator.urls).length;
				}
				this.changePage();
			},
			previousPage: function () {
				this.paginator.currentPage--;
				if (this.currentPage < 1) {
					this.currentPage = 1;
				}
				this.changePage();
			},
			gotoPage: function (index) {
				this.paginator.currentPage = index;
				this.changePage();
			},
			changePage: function () {
				let startIndex = (this.paginator.currentPage - 1) * this.limit;
				let endIndex = startIndex + this.limit;
				eventBus.$emit('changePage', {startIndex: startIndex, endIndex: endIndex});
			}
		}
	}
</script>

<style scoped>

</style>
